import {createRequestDataSource} from '@ngneat/elf-requests';
import {executionLineStore} from '@store/invoices/executionLines/executionLine.store';
import {select} from '@ngneat/elf';
import {ExecutionLine} from '@store/invoices/executionLines/executionLine.model';

export const getExecutionLinesDataSource = createRequestDataSource({
  store: executionLineStore,
  data$: () => executionLineStore.pipe( select((state) => {
    const entities = Object.values(state.entities);
    return state.pagination.pages[state.pagination.currentPage]?.map(id => entities.find(e => e.id === id) as ExecutionLine).filter(e => !!e) || [];
  })),
  requestKey: 'getExecutionLinesDataSource',
  dataKey: 'executionLines',
});

export const getExecutionLinesTotalDataSource = createRequestDataSource({
  store: executionLineStore,
  data$: () => executionLineStore.pipe(select((state) => state.total)),
  requestKey: 'getExecutionLinesTotalDataSource',
  dataKey: 'total',
});
